/**
 * 🔒 ProtectedRoute - Centralized Authentication Guard
 *
 * Security Features:
 * - Waits for auth initialization before making decisions
 * - Redirects unauthenticated users to home page
 * - Shows nothing during auth check (prevents flash of protected content)
 * - Uses AuthContext as single source of truth
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';

const ProtectedRoute = ({ children }) => {
    const { loading, authType } = useAuth();
    const location = useLocation();

    // 🔒 SECURITY: While auth is loading, show nothing
    // This prevents flash of protected content before auth check completes
    if (loading) {
        return null;
    }

    // 🔒 SECURITY: If not authenticated, redirect to home
    // Only authType === 'authenticated' is allowed
    if (authType !== 'authenticated') {
        // Silently redirect to home - no error exposure to guests
        return <Navigate to="/" replace />;
    }

    // User is authenticated - render the protected content
    return children;
};

export default ProtectedRoute;
